import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { DesignInspirationPanel } from 'Pages/TeamDashboard/CreateReview/components/DesignInspirationPanel';

import styles from './styles.module.scss';

export const DeeperInsightsDetails = ({
  data, insightUuid, currentFeedbackUuid, isPublicView = false, isCardExpanded = true,
}) => {
  const currentRecord = useSelector(state => state.historyReducer.currentRecord);

  // Show Design Inspiration panel only if there is a current feedback UUID
  const showDesignInspiration = Boolean(currentFeedbackUuid);

  return (
    <div className={cn(styles['deeper-insights-details'])}>
      {showDesignInspiration && (
        <DesignInspirationPanel
          insight={data}
          insightUuid={insightUuid || data.uuid}
          currentFeedbackUuid={currentFeedbackUuid || currentRecord?.uuid}
          isPublicView={isPublicView}
          isCardExpanded={isCardExpanded}
        />
      )}
      <div className={styles['main-section']} >
        {data.high_impact_recommendation && (
          <div className={styles['recommendation-section']}>
            <p className={styles['section-label']}>
              High-impact recommendation
            </p>
            <p className={styles['recommendation-text']}>
              {data.high_impact_recommendation}
            </p>
          </div>
        )}
        {data.action_steps && data.action_steps.length > 0 && (
          <div className={styles['action-steps-section']}>
            <ul className={styles['action-list']}>
              {data.action_steps.map((step, stepIndex) => (
                <li key={stepIndex} className={styles['action-item']}>
                  {step}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {data.most_impacted_segment && (
        <div className={styles['impact-section']}>
          <p className={styles['section-label']}>
            Most impacted segment
          </p>
          <p className={styles['impact-text']}>
            {data.most_impacted_segment}
          </p>
        </div>
      )}
      {data.primary_metrics_moved && data.primary_metrics_moved.length > 0 && (
        <div className={styles['metrics-section']}>
          <p className={styles['section-label']}>
            Primary metrics moved
          </p>
          <p className={styles['metrics-text']}>
            {data.primary_metrics_moved.join(', ')}
          </p>
        </div>
      )}
    </div>
  );
};

DeeperInsightsDetails.propTypes = {
  data: PropTypes.object.isRequired,
  insightUuid: PropTypes.string,
  currentFeedbackUuid: PropTypes.string,
  isPublicView: PropTypes.bool,
  isCardExpanded: PropTypes.bool,
};

DeeperInsightsDetails.defaultProps = {
  insightUuid: undefined,
  currentFeedbackUuid: undefined,
  isPublicView: false,
  isCardExpanded: true,
};
